import React, { Component } from "react";

import Warning from "../../../img/warning.svg"

export class ConfirmRun extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="wrapper">
        <img src={Warning} alt="Warning icon." style={{width: "108px", margin: "0 auto"}} />
        <h3>Are you sure you want to run these cycles?</h3>
        <p>You won't be able to edit these cycles again.</p>
        <div className="button-row">
          <button className="secondary" onClick={() => this.props.setDialogDisplay({
            id: this.props.id,
            displayDialog: false
          })}>Cancel</button>
          <button className="primary" onClick={() => {
            this.props.setInnerSection({
              id: this.props.id,
              innerSection: "RUN_TABLE"
            })
            this.props.setDialogDisplay({
              id: this.props.id,
              displayDialog: false
            })
          }}>Run</button>
        </div>
      </div>
    )
  }
}
